import { render, staticRenderFns } from "./PageToggleTransition.vue?vue&type=template&id=8151b542&"
import script from "./PageToggleTransition.vue?vue&type=script&lang=js&"
export * from "./PageToggleTransition.vue?vue&type=script&lang=js&"
import style0 from "./PageToggleTransition.vue?vue&type=style&index=0&id=8151b542&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports